import Vuex from 'vuex'
import Vue from 'vue'
import favorites from './modules/favorites/favorites'
import locations from "./modules/locations/locations";
import filtration from "./modules/filtration/filtration";
import order from "./modules/order";
import {isBoolean} from "lodash/lang";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isMobile: false,
    },
    mutations: {
        setIsMobile(state, val) {
            if(isBoolean(val)) state.isMobile = val
        },
    },
    getters: {
        getIsMobile: (state) => state.isMobile,
    },

    modules: {
        favorites,
        locations,
        filtration,
        order,
    },
})
